var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "op-goods", on: { click: _vm.goGoodsDetail } },
    [
      _c("div", { staticClass: "goods-img" }, [
        _c("img", { attrs: { src: _vm.goodsData.skuImage, alt: "" } })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "goods-info" },
        [
          _c("div", { staticClass: "goods-title" }, [
            _vm._v(_vm._s(_vm.goodsData.productName))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "goods-sku" }, [
            _c("div", { staticClass: "sku-info" }, [
              _vm._v(_vm._s(_vm.goodsData.specificationValue))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "num" }, [
              _vm._v("x" + _vm._s(_vm.goodsData.quantity))
            ])
          ]),
          _vm._v(" "),
          _vm.goodsData.aaa
            ? _c(
                "van-tag",
                {
                  attrs: {
                    color: "rgba(238,46,80,0.2)",
                    "text-color": "#EE2E50",
                    round: ""
                  }
                },
                [_vm._v("自营")]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }